(function () {
  var PAIRS = [
    { name: 'WOMEN', menuId: 'megamenu-shop-women' },
    { name: 'MEN', menuId: 'megamenu-shop-men' }
  ];

  var openMenu = null;
  var rafId = null;

  // Continuously track the header's live bottom edge (read fresh every
  // frame via getBoundingClientRect) while a menu is open. This is what
  // actually keeps the panel glued to the header through sticky transitions,
  // scroll, and announcement-bar height changes - a one-time calculation
  // always goes stale the moment the header's on-screen position changes.
  function trackPosition() {
    if (!openMenu) { rafId = null; return; }
    var header = document.querySelector('#mainHeader');
    var bottom = header ? header.getBoundingClientRect().bottom : 97;
    if (bottom < 0) bottom = 0;
    openMenu.style.top = Math.round(bottom) + 'px';
    rafId = window.requestAnimationFrame(trackPosition);
  }

  function startTracking(menu) {
    openMenu = menu;
    if (rafId == null) rafId = window.requestAnimationFrame(trackPosition);
  }

  function stopTracking() {
    openMenu = null;
    if (rafId != null) { window.cancelAnimationFrame(rafId); rafId = null; }
  }

  function closeAllMegamenus(except) {
    document.querySelectorAll('[id^="megamenu-"]').forEach(function (menu) {
      if (menu !== except) menu.style.display = 'none';
    });
    if (!except) stopTracking();
  }

  function init() {
    if (window.innerWidth < 778) return;
    var desktopNav = document.querySelector('#mainHeader .menu.large-only') || document.querySelector('#mainHeader');
    if (!desktopNav) return;

    var wired = false;

    PAIRS.forEach(function (pair) {
      var trigger = null;
      desktopNav.querySelectorAll('summary[data-name]').forEach(function (el) {
        if (!trigger && el.getAttribute('data-name') === pair.name) trigger = el;
      });
      var menu = document.getElementById(pair.menuId);
      if (!trigger || !menu) return;

      menu.style.display = 'none';
      wired = true;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isVisible = menu.style.display === 'block';
        var details = trigger.closest('details');
        if (details) details.removeAttribute('open');
        closeAllMegamenus(menu);
        if (isVisible) {
          menu.style.display = 'none';
          stopTracking();
        } else {
          menu.style.display = 'block';
          startTracking(menu);
        }
      });
    });

    if (wired) {
      document.addEventListener('click', function (e) {
        var anyOpen = false;
        document.querySelectorAll('[id^="megamenu-"]').forEach(function (menu) {
          if (menu.style.display === 'block' && !menu.contains(e.target)) {
            menu.style.display = 'none';
          } else if (menu.style.display === 'block') {
            anyOpen = true;
          }
        });
        if (!anyOpen) stopTracking();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();